import { render, staticRenderFns } from "./VoltageRecord.vue?vue&type=template&id=f08d458c&scoped=true&"
import script from "./VoltageRecord.vue?vue&type=script&lang=js&"
export * from "./VoltageRecord.vue?vue&type=script&lang=js&"
import style0 from "./VoltageRecord.vue?vue&type=style&index=0&id=f08d458c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08d458c",
  null
  
)

export default component.exports